// CozyCub — JS propio. Un archivo, un init por componente.
// La etiqueta <script> se repite en varias secciones (cada una la necesita
// disponible aunque el usuario reordene/quite secciones); esta bandera evita
// inicializar dos veces si el navegador ejecuta el archivo más de una vez.
if (!window.__ccScriptsInit) {
  window.__ccScriptsInit = true;
  document.addEventListener('DOMContentLoaded', function () {
    initReveals();
    initContadores();
    initGaleriaProducto();
    initVariantesProducto();
  });
}

function initReveals() {
  var els = document.querySelectorAll('.cc-reveal');
  if (!els.length) return;

  var mostrarTodo = function () {
    els.forEach(function (el) { el.classList.add('cc-visible'); });
  };

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
    mostrarTodo();
    return;
  }

  // Lo que ya está en pantalla al cargar (p. ej. el hero) se muestra al
  // instante, sin esperar a que el observer dispare — así el contenido
  // nunca depende de un scroll o de un timing de IO para ser visible.
  els.forEach(function (el, i) {
    el.style.setProperty('--cc-delay', Math.min(i % 4, 3) * 0.1 + 's');
    var r = el.getBoundingClientRect();
    if (r.top < window.innerHeight && r.bottom > 0) {
      el.classList.add('cc-visible');
    }
  });

  var pendientes = document.querySelectorAll('.cc-reveal:not(.cc-visible)');
  if (!pendientes.length) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('cc-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
  );
  pendientes.forEach(function (el) { observer.observe(el); });

  // Red de seguridad: si por lo que sea el observer no dispara para algún
  // elemento (dispositivo lento, pestaña en segundo plano...), se muestra
  // igual pasado un tiempo prudencial en vez de quedar invisible para siempre.
  setTimeout(mostrarTodo, 2500);
}

function initContadores() {
  var els = document.querySelectorAll('[data-cc-contador]');
  if (!els.length) return;
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        var el = entry.target;
        var fin = parseFloat(el.getAttribute('data-cc-contador')) || 0;
        var dur = 1200;
        var inicio = null;
        function paso(ts) {
          if (!inicio) inicio = ts;
          var progreso = Math.min((ts - inicio) / dur, 1);
          el.textContent = Math.round(progreso * fin);
          if (progreso < 1) requestAnimationFrame(paso);
        }
        requestAnimationFrame(paso);
      });
    },
    { threshold: 0.6 }
  );
  els.forEach(function (el) { observer.observe(el); });
}

function initGaleriaProducto() {
  var minis = document.querySelectorAll('[data-cc-mini]');
  if (!minis.length) return;
  var principal = document.getElementById('cc-galeria-principal-img');
  if (!principal) return;
  minis.forEach(function (mini) {
    mini.addEventListener('click', function () {
      principal.src = mini.getAttribute('data-full');
      minis.forEach(function (m) { m.classList.remove('cc-galeria__mini--activa'); });
      mini.classList.add('cc-galeria__mini--activa');
    });
  });
}

function initVariantesProducto() {
  var contenedor = document.getElementById('cc-opciones');
  var datosEl = document.getElementById('cc-variantes-json');
  if (!contenedor || !datosEl) return;

  var variantes;
  try {
    variantes = JSON.parse(datosEl.textContent);
  } catch (e) {
    return;
  }

  var grupos = contenedor.querySelectorAll('[data-cc-opcion-index]');
  var seleccion = [];
  grupos.forEach(function (grupo) {
    var activo = grupo.querySelector('.cc-opcion__valor--activa');
    seleccion.push(activo ? activo.getAttribute('data-valor') : null);
  });

  var inputId = document.getElementById('cc-variant-id');
  var precioEl = document.getElementById('cc-precio');
  var boton = document.getElementById('cc-boton-comprar');
  var textoNormal = boton ? boton.getAttribute('data-texto-normal') || boton.textContent.trim() : '';
  if (boton) boton.setAttribute('data-texto-normal', textoNormal);

  function actualizar() {
    var variante = variantes.filter(function (v) {
      return v.options.every(function (opcion, i) { return opcion === seleccion[i]; });
    })[0];
    if (!variante) return;
    if (inputId) inputId.value = variante.id;
    if (precioEl) {
      precioEl.innerHTML = variante.compare_at_price
        ? '<span class="cc-cta__precio-antes">' + variante.compare_at_price + '</span>' + variante.price
        : variante.price;
    }
    if (boton) {
      boton.disabled = !variante.available;
      boton.textContent = variante.available ? textoNormal : (boton.getAttribute('data-texto-agotado') || textoNormal);
    }
  }

  grupos.forEach(function (grupo, i) {
    grupo.querySelectorAll('.cc-opcion__valor').forEach(function (btn) {
      btn.addEventListener('click', function () {
        grupo.querySelectorAll('.cc-opcion__valor').forEach(function (b) { b.classList.remove('cc-opcion__valor--activa'); });
        btn.classList.add('cc-opcion__valor--activa');
        seleccion[i] = btn.getAttribute('data-valor');
        actualizar();
      });
    });
  });
}

/* Barra fija de compra en móvil: aparece cuando el botón principal sale de pantalla */
(function () {
  function initBarraMovil() {
    var barra = document.getElementById('cc-barra-movil');
    var principal = document.getElementById('cc-boton-comprar');
    var boton = document.getElementById('cc-barra-movil-boton');
    if (!barra || !principal) return;
    function actualizar() {
      var r = principal.getBoundingClientRect();
      var enPantalla = r.top < window.innerHeight && r.bottom > 0;
      var visible = !enPantalla;
      barra.classList.toggle('cc-barra-movil--visible', visible);
      barra.setAttribute('aria-hidden', visible ? 'false' : 'true');
      if (boton) boton.tabIndex = visible ? 0 : -1;
    }
    window.addEventListener('scroll', actualizar, { passive: true });
    window.addEventListener('resize', actualizar);
    actualizar();
    if (boton) {
      boton.addEventListener('click', function () {
        var destino = document.getElementById('cc-opciones') || principal;
        destino.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initBarraMovil);
  else initBarraMovil();
})();

/* Oferta 2 unidades: permite elegir un color/variante distinto para la segunda almohada */
(function () {
  function initBundleColores() {
    var form = document.getElementById('cc-form-producto');
    var segundo = document.getElementById('cc-bundle-segundo');
    var contenedor2 = document.getElementById('cc-opciones-2');
    var datosEl = document.getElementById('cc-variantes-json');
    var inputId1 = document.getElementById('cc-variant-id');
    if (!form || !segundo || !contenedor2 || !datosEl || !inputId1) return;

    var variantes;
    try { variantes = JSON.parse(datosEl.textContent); } catch (e) { return; }

    var seleccion2 = [];
    var grupos2 = contenedor2.querySelectorAll('[data-cc-opcion-index]');
    grupos2.forEach(function (grupo) {
      var activo = grupo.querySelector('.cc-opcion__valor--activa');
      seleccion2.push(activo ? activo.getAttribute('data-valor') : null);
    });
    grupos2.forEach(function (grupo, i) {
      grupo.querySelectorAll('.cc-opcion__valor').forEach(function (btn) {
        btn.addEventListener('click', function () {
          grupo.querySelectorAll('.cc-opcion__valor').forEach(function (b) { b.classList.remove('cc-opcion__valor--activa'); });
          btn.classList.add('cc-opcion__valor--activa');
          seleccion2[i] = btn.getAttribute('data-valor');
        });
      });
    });

    function cantidad() {
      var r = form.querySelector('input[name="quantity"]:checked');
      return r ? parseInt(r.value, 10) : 1;
    }
    function variantePorOpciones(sel) {
      return variantes.filter(function (v) {
        return v.options.every(function (o, i) { return o === sel[i]; });
      })[0];
    }
    function mostrar() { segundo.hidden = cantidad() < 2; }
    form.querySelectorAll('input[name="quantity"]').forEach(function (r) { r.addEventListener('change', mostrar); });
    mostrar();

    form.addEventListener('submit', function (ev) {
      if (cantidad() < 2) return;
      var v2 = variantePorOpciones(seleccion2);
      if (!v2) return;
      var id1 = parseInt(inputId1.value, 10);
      if (v2.id === id1) return; // mismo color: el envío normal con cantidad 2 funciona
      ev.preventDefault();
      var boton = document.getElementById('cc-boton-comprar');
      if (boton) boton.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id1, quantity: 1 }, { id: v2.id, quantity: 1 }] })
      }).then(function (res) {
        if (!res.ok) throw new Error('add failed');
        window.location.href = '/cart';
      }).catch(function () {
        if (boton) boton.disabled = false;
        var aviso = document.getElementById('cc-bundle-error');
        if (!aviso) {
          aviso = document.createElement('p');
          aviso.id = 'cc-bundle-error';
          aviso.className = 'cc-opinion__error';
          aviso.setAttribute('role', 'alert');
          segundo.appendChild(aviso);
        }
        aviso.textContent = 'Sorry, one of those colors is not available right now. Please choose another one.';
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initBundleColores);
  else initBundleColores();
})();
